import React from "react";
import styled from "styled-components";
import { fonts } from "../../common/mixins";

// The order-summary line-item primitives. They live here rather than in
// order-info.tsx because ticket-info.tsx, split-order and ProductRowsSection all
// build rows out of them; order-info.tsx re-exports them for compatibility.

export const ItemTitleWrapper = styled.div`
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0;
`;

export const ItemTitle = styled.p`
  margin: 0;
  line-height: 20px;
  ${fonts.normalTextDarkGray()};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TicketDiscount = styled(ItemTitle)`
  font-style: italic;
  max-width: 100%;
`;

export const ItemPrice = styled(ItemTitle)`
  white-space: nowrap;
  flex: 0 0 auto;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  flex: 1;
`;

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 36px;
`;

export const ItemMeta = styled.p`
  margin: 0;
  line-height: 18px;
  ${fonts.normalTextMedium()};
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #696781;
`;

export const TicketSection = styled.p`
  margin: 0;
  line-height: 20px;
  ${fonts.normalTextSmall()};
  color: #696781;
  font-size: 15px;
`;

export function TicketNameWithDiscount({
  name,
  discountName,
}: {
  name: string;
  discountName: string;
}) {
  return (
    <ItemTitleWrapper>
      <ItemTitle
        as="span"
        style={{ flexShrink: 0, maxWidth: "100%", marginRight: 4 }}
      >
        {name}
      </ItemTitle>
      <TicketDiscount as="span" style={{ flexShrink: 0 }}>
        {`- ${discountName}`}
      </TicketDiscount>
    </ItemTitleWrapper>
  );
}
